import Pagination from '../Pagination'
import React, { useMemo } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import copy from '../../assets/icons/copy.svg'
import edit from '../../assets/icons/edit.svg'
import trash from '../../assets/icons/trashRed.svg'
import { useDispatch, useSelector } from 'react-redux';
import {deleteSiswa, getSiswa, updateSiswa, updateSiswaAccess, updateStateSiswa} from '../../features/siswaSlice';

import imgErrorValidation from '../../utils/imgErrorValidation';
import arrowDownIcon from '../../assets/icons/arrow-right.svg'
import orangImage from '../../assets/images/user-foto.png'
import AlertModal from '../AlertModal';
import { useState } from 'react';

let PageSize = 10;

function Table() {
    const { listSiswa, isLoading, urutan, currentPage } = useSelector(state => state.siswa)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [alertModalDelete, setAlertModalDelete] = useState(false)
    const [idUserToDelete, setIdUserToDelete] = useState(null)

    const currentSiswaTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;

        const sortedData = [...listSiswa].sort((a, b) => {
            if (urutan.column === 'nama') {
                return urutan.order === 'asc'
                    ? a.nama.localeCompare(b.nama)
                    : b.nama.localeCompare(a.nama);
            } else if (urutan.column === 'niy') {
                return urutan.order === 'asc'
                    ? parseInt(a.niy) - parseInt(b.niy)
                    : parseInt(b.niy) - parseInt(a.niy);
            }
        });

        return sortedData?.slice(firstPageIndex, lastPageIndex);
    }, [isLoading, listSiswa, urutan, currentPage]);

    function handleDetail(id) {
        navigate(`/karyawan/edit/${id}`)
    }

    function handleDelete(id) {
        dispatch(deleteSiswa(id))
            .then((res) => {
                const totalItems = listSiswa.length - 1;
                const lastItemOnPage = totalItems % PageSize === 0;
                if (lastItemOnPage && currentPage > 1) {
                    dispatch(updateStateSiswa({ name: 'currentPage', value: 1 }));
                }

                if (res.meta.requestStatus === 'fulfilled') {

                }
                dispatch(getSiswa({}))
            })
    }

    function handleCopyNiy(niy) {
        navigator.clipboard.writeText(niy)
    }

    function handleSort(column) {
        if (urutan.column === column) {
            dispatch(
                updateStateSiswa({
                    name: 'urutan',
                    value: {
                        column,
                        order: urutan.order === 'asc' ? 'desc' : 'asc'
                    }
                })
            )
        } else {
            dispatch(
                updateStateSiswa({
                    name: 'urutan',
                    value: {
                        column,
                        order: 'asc'
                    }
                })
            )
        }
    }

    const handleCheck = (id, checked) => {
        dispatch(
            updateSiswaAccess({
                id: id,
                access: checked,
            })
        ).then(() => {
            dispatch(getSiswa({}))
        });
    };

    return (
        <>
            <table className='table'>
                <thead>
                <tr>
                    <th className='th-niy'>
                        <div className='wrap-filter'>
                            NIY
                            <img src={arrowDownIcon} alt=""
                                 onClick={() => handleSort('niy')}
                                 className={urutan.column === 'niy' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-name'>
                        <div className='wrap-filter'>
                            Nama Siswa
                            <img src={arrowDownIcon} alt="" onClick={() => handleSort('nama')}
                                 className={urutan.column === 'nama' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-jabatan'>Kelas</th>
                    <th className='th-jabatan'>Sakit</th>
                    <th className='th-jabatan'>Izin</th>
                    <th className='th-jabatan'>Alfa</th>
                    <th className='th-jabatan'>Access</th>
                </tr>
                </thead>

                <tbody>
                {
                    isLoading ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentSiswaTableData.length === 0 ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr> :
                            currentSiswaTableData?.map((item, key) => {
                                return (
                                    <tr key={key}>
                                        <td className='niy-col'>{item?.niy}</td>
                                        <td className='row-img'>
                                            <img src={orangImage} onError={imgErrorValidation} alt="" />
                                            {item?.nama}
                                        </td>

                                        <td>{item?.classes.category}</td>
                                        <td>{item?.sakit}</td>
                                        <td>{item?.izin}</td>
                                        <td>{item?.Alfa}</td>

                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={item?.access || false}
                                                onChange={(e) => handleCheck(item?.id, e.target.checked)}
                                            />
                                        </td>

                                        <td className='action-col'>
                                            <div>
                                                <img src={copy} alt='' onClick={() => handleCopyNiy(item?.niy)} />
                                                <Link to={`/siswa/edit/${item?.id}`}>
                                                    <img src={edit} alt="" />
                                                </Link>
                                                <img src={trash} alt='' onClick={() => {
                                                    setAlertModalDelete(true)
                                                    setIdUserToDelete(item.id)
                                                }}
                                                />
                                            </div>
                                        </td>


                                    </tr>
                                )
                            })
                }
                </tbody>
            </table>

            {!isLoading &&
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={listSiswa?.length}
                    pageSize={PageSize}
                    onPageChange={page =>
                        dispatch(updateStateSiswa({ name: 'currentPage', value: page }))
                    }
                />
            }

            {alertModalDelete && <AlertModal
                heading={'Hapus Siswa'}
                message={'Apakah anda yakin ingin menghapus siswa ini?'}
                onCancel={() => setAlertModalDelete(false)}
                onConfirm={() => handleDelete(idUserToDelete)}
            />}
        </>
    )
}

export default Table